import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

class CustomFormatter {
    interpolate(message, values) {
        const regex = /:\w+/g;
        return message.replace(regex, (match) => {
            const key = match.slice(1);
            return values && key in values ? values[key] : match;
        });
    }
}

const { adminlte, ...messages } = window.trans;

export const i18n = new VueI18n({
    locale: 'en',
    formatter: new CustomFormatter(),
    silentTranslationWarn: process.env.NODE_ENV === 'production',
    messages: {
        en: {
            ...adminlte,
            ...messages,
        },
    },
});
